export default {"src":"/_next/static/media/403_Ping.8a02ab04.svg","height":246,"width":304};